import React from 'react';

const ML_Deep_Learning = () => {
    return (
        <div>ML_Deep_Learning Component</div>
    );
}

export default ML_Deep_Learning;
